import { FC } from 'react';
import { useGetWebhooks } from '../hooks';
import { DestinationsContext, DestinationsContextState } from './DestinationsContext';

export const DestinationsProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const savedWebhooks = useGetWebhooks();

  const value: DestinationsContextState = {
    savedWebhooks,
  };

  return <DestinationsContext.Provider value={value}>{children}</DestinationsContext.Provider>;
};
